module.exports = require('./SearchHighlightCell');
